module.exports = require('./SearchHighlightCell');
